export const httpUrl = (url) => {
  if (!url) { return null; }
  return url.match(/:\/\//) ? url : `http://${url}`;
};

export const instagramUrl = (username) => {
  if (!username) { return null; }
  return `https://www.instagram.com/${username.replace(/^@/, '')}`;
};
